import Vue from "vue";
import Detail from "./detail.vue";

export default {
    detail:(info)=>{
      const constructor = Vue.extend({
          render(h){
              return h(Detail,{props:{detail:info}});
          },
      });
      let detailvm = new constructor().$mount();
      document.body.appendChild(detailvm.$el);
    },
}



// WEBPACK FOOTER //
// ./src/components/artwork/index.js